import { useEsmsStore } from '../../store/esms.store';
import EsmsDashboardFilters from './EsmsDashboardFilters';
import EsmsOverviewCards from './EsmsOverviewCards';
import EsmsTrendChart from './EsmsTrendChart';
import EsmsByTypeTable from './EsmsByTypeTable';
import EsmsBrandnameSection from './EsmsBrandnameSection';
import EsmsZaloOASection from './EsmsZaloOASection';
import EsmsTopRecipientsTable from './EsmsTopRecipientsTable';
import EsmsPriceReferencePanel from './EsmsPriceReferencePanel';
import EsmsPhoneLookup from './EsmsPhoneLookup';
import EsmsOtpStatsSection from './EsmsOtpStatsSection';
import EsmsErrorBox from './EsmsErrorBox';

interface Props { isDark: boolean; theme?: Record<string, string> }

export default function EsmsDashboardContent({ isDark }: Props) {
  const {
    overview, trend, isLoading, error, fetchedKey, reportFrom, reportTo,
    brandnames, brandnamesLoading, brandnamesError,
    zaloOA, zaloOALoading, zaloOAError,
    topRecipients, topRecipientsLoading, topRecipientsError, topRecipientsDisabled,
    priceReference, priceReferenceLoading, priceReferenceError,
    otpStats, otpStatsLoading, otpStatsError, otpStatsDisabled,
  } = useEsmsStore();
  const hasFetched = !!fetchedKey;

  return (
    <>
      <EsmsDashboardFilters isDark={isDark} />
      {isLoading && (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-cyan-500" />
        </div>
      )}

      {error && !isLoading && (
        <EsmsErrorBox error={error} isDark={isDark} />
      )}

      {!isLoading && !hasFetched && !error && (
        <div className="flex flex-col items-center justify-center h-64">
          <p className={`text-lg ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>
            Chọn khoảng thời gian và nhấn <span className="text-cyan-400 font-medium">"Chạy report"</span> để xem dữ liệu eSMS
          </p>
        </div>
      )}

      {!isLoading && hasFetched && overview && (
        <div className="mt-4 sm:mt-6 space-y-4 sm:space-y-6">
          <h2 className={`text-xl sm:text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
            eSMS Dashboard <span className={`text-base font-normal ${isDark ? 'text-cyan-400/80' : 'text-cyan-600'}`}>({reportFrom} — {reportTo})</span>
          </h2>

          <EsmsOverviewCards overview={overview} isDark={isDark} />
          <EsmsTrendChart trend={trend} isDark={isDark} />
          <EsmsByTypeTable byType={overview.byType} isDark={isDark} />
          <EsmsBrandnameSection brandnames={brandnames} isDark={isDark} isLoading={brandnamesLoading} error={brandnamesError} />
          <EsmsZaloOASection oas={zaloOA} isDark={isDark} isLoading={zaloOALoading} error={zaloOAError} />
          <EsmsTopRecipientsTable recipients={topRecipients} isDark={isDark} isLoading={topRecipientsLoading} error={topRecipientsError} disabled={topRecipientsDisabled} />
          <EsmsOtpStatsSection data={otpStats} isDark={isDark} isLoading={otpStatsLoading} error={otpStatsError} disabled={otpStatsDisabled} />
          <EsmsPhoneLookup isDark={isDark} from={reportFrom} to={reportTo} disabled={topRecipientsDisabled} />
          <EsmsPriceReferencePanel data={priceReference} isDark={isDark} isLoading={priceReferenceLoading} error={priceReferenceError} />
        </div>
      )}
    </>
  );
}
